<template>
  <v-container>
    <v-row align="center" class="row--35">
      <v-col lg="5" md="5" cols="12">
        <div class="thumbnail">
          <slot name="thum-img"></slot>
        </div>
      </v-col>
      <v-col lg="7" md="7" cols="12">
        <div class="about-inner inner">
          <div class="section-title">
            <div class="icon" v-html="iconSvg(icon)"></div>
            <h2 class="heading-title">Welcome to R.A.D Software Development Services</h2>
            <p class="description">
              Founded by Roldhan Arana Dasalla, R.A.D Software Development Services brings over 9 years of expertise in web and mobile development. Our name, R.A.D, represents our founder's commitment to delivering Rapid, Agile, and Dynamic solutions to our clients.
            </p>
            <p class="description">
              We specialize in Laravel and Vue.js development, creating robust, scalable, and innovative web applications. Our team combines technical excellence with industry best practices to deliver solutions that drive business growth and success.
            </p>
            <div class="purchase-btn">
              <router-link class="btn-transparent" to="/contact"
                >Start Your Project</router-link
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        icon: "send",
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>
